"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("./Text"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  display: inline-block;\n  font-weight: normal;\n  letter-spacing: 0.0375em;\n  line-height: 1.125;\n  text-transform: uppercase;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Badge = (0, _styledComponents["default"])(_Text["default"].span)(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.pill;
});
Badge.displayName = 'Badge';
Badge.defaultProps = {
  theme: _theme["default"],
  px: 2,
  py: 1,
  bg: 'primary',
  color: 'white',
  fontSize: 1
};
var _default = Badge;
exports["default"] = _default;